import { Component, OnDestroy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AuthService, AccountsService, Store } from '../../shared/services';
import { Router } from '@angular/router';
import { TopLevelWithoutHeaderComponent } from '../../shared/models';

@Component({
  styles: [require('./add-account.component.scss')],
  template: require('./add-account.component.pug')
})
export class AddAccountComponent extends TopLevelWithoutHeaderComponent implements OnDestroy  {

  fg: FormGroup = new FormGroup({});
  authErrorMessage: string = 'Invalid credentials';
  authError: boolean = false;

  constructor(
      private _authSvc: AuthService,
      private _router: Router,
      private _accService: AccountsService,
      public store: Store
      ) {
          super(store);
  }

  ngOnDestroy() {
     this.componentDestroy();
  }

  goBackClicked() {
      let accounts = this._accService.getAccounts();
      if (accounts.length > 0) {
        this._router.navigate(['accounts']);
      } else {
         this._router.navigate(['']);
      }
  }

  register(e: MouseEvent) {
      e.preventDefault();
      this.authError = false;
      let creds = this.fg.value;

      this._authSvc.authenticate(creds)
        .subscribe(
            res => this._onSuccesfullAuth(res),
            err => this._onErrorAuth(err),
            () => console.log('Auth completed')
        );
  }

  private _onSuccesfullAuth(res) {
      this.authError = false;
      this._router.navigate(['/dashboard']);
  }

  private _onErrorAuth(res) {
      this.authError = true;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/accounts/add-account/add-account.component.ts